import { render } from "./myHome.vue?vue&type=template&id=3be2c12d&scoped=true"
import script from "./myHome.vue?vue&type=script&lang=js"
export * from "./myHome.vue?vue&type=script&lang=js"

import "./myHome.vue?vue&type=style&index=0&id=3be2c12d&scoped=true&lang=css"
import "./myHome.vue?vue&type=style&index=1&id=3be2c12d&lang=css"

import exportComponent from "/home/runner/work/user-ui/user-ui/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3be2c12d"]])

export default __exports__